import { IMenu } from '../models'
import CONFIG from '../../config'

const menuSuperAdmin: IMenu[] = [
  {
    id: 1,
    name: 'Administrador de usuarios',
    icon: 'users',
    url: CONFIG.ROUTES.ADMIN.USERS.HOME,
    favoriteShow: false
  },
  {
    id: 201,
    name: 'Grupos familiares',
    icon: 'users',
    url: CONFIG.ROUTES.ADMIN.FAMILY.HOME,
    favoriteShow: false
  },
  {
    id: 2,
    name: 'Administrador de control y prevención',
    icon: 'control-prevencion',
    url: CONFIG.ROUTES.ADMIN.CONTROLPREVENTION.HOME,
    favoriteShow: false
  },
  {
    id: 3,
    name: 'Administrador de alertas',
    icon: 'alert-icon',
    url: CONFIG.ROUTES.ADMIN.ALERTS,
    favoriteShow: false
  },
  {
    id: 12,
    name: 'Probar Emails',
    icon: 'control-prevencion',
    url: CONFIG.ROUTES.ADMIN.MAILING,
    favoriteShow: false
  },
  {
    id: 200, // used in table "favourite"
    name: 'Anuncios Conecta con INDISA',
    icon: 'alert-icon',
    url: CONFIG.ROUTES.ADMIN.ADS.HOME,
    favoriteShow: false
  }
];
export default menuSuperAdmin;